import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  CustomButton,
  CustomDatePicker,
  CustomDropdown,
  CustomTextInput,
  CustomTimePicker,
} from "../../../components";
import styles from "./Calendar.module.css";
import AxiosInstance, { TokenService } from "../../../services/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PopupModal from "../../../components/PopupModal/PopupModal"
const categoryOptions = [
  { label: "School", value: 1 },
  { label: "College", value: 2 },
  { label: "Holiday", value: 3 },
];
const CalendarInfoCreate = () => {
  const location = useLocation();
  const user = TokenService.getUser();
  const userId = user?.id || 0;
  const client_id = user?.client_data[0].client_id || "";
  const clientData = user?.client_data[0] || [];
  const school_id = clientData?.school_id || "";
  const [formData, setFormData] = useState({
    category: "",
    school: clientData.school_name,
    fromDate: null,
    toDate: null,
    fromTime: null,
    toTime: null,
    subject: "",
    venue: "",
    description: "",
  });
  const [modalState, setModalState] = useState({
    open: false,
    type: "success",   // "success" | "error"
    message: "",
    redirectPath: "",
  });


  const [categoryList, setCategoryList] = useState([]);
  const { DATAS } = location.state || {};



  const formatTime = (time) => {
    if (!time) return null;
    return dayjs(time).format("HH:mm");
  };


  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  /* -------------------- Handlers -------------------- */

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleDropdownChange = (name, option) => {
    setFormData((prev) => ({ ...prev, [name]: option }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value, // ✅ keep dayjs object
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };



  const handleTimeChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  /* -------------------- Validation -------------------- */

  const validateForm = () => {
    const newErrors = {};
    if (!formData.category) newErrors.category = translations.errors.categoryRequired;
    if (!formData.fromDate) newErrors.fromDate = translations.errors.fromDateRequired;
    if (!formData.toDate) newErrors.toDate = translations.errors.toDateRequired;
    if (
      formData.fromDate &&
      formData.toDate &&
      dayjs(formData.toDate).isBefore(dayjs(formData.fromDate))
    ) {
      newErrors.toDate = "To date must be after From date";
    }
    if (!formData.fromTime) newErrors.fromTime = translations.errors.fromTimeRequired;
    if (!formData.toTime) newErrors.toTime = translations.errors.toTimeRequired;
    if (!formData.subject.trim()) newErrors.subject = translations.errors.subjectRequired;
    if (!formData.venue.trim()) newErrors.venue = translations.errors.venueRequired;
    if (!formData.description.trim())
      newErrors.description = translations.errors.descriptionRequired;
    return newErrors;
  };
  const navigate = useNavigate();
  /* -------------------- Submit -------------------- */

  const handleCancel = () => {
    setFormData({});
    navigate("/user/calenderList")
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {

      if (DATAS) {
        const payload = {
          client_id: client_id,
          event_category: formData.category.value,
          start_date: formData.fromDate?.format("YYYY-MM-DD"),
          end_date: formData.toDate?.format("YYYY-MM-DD"),
          start_time: formatTime(formData.fromTime),
          end_time: formatTime(formData.toTime),
          event_subject: formData.subject,
          event_venue: formData.venue,
          event_description: formData.description,
          is_visible_to_all_school: 1,
          my_schools: school_id,
          updated_by: userId
        };
        const response = await AxiosInstance.put(
          `/school/updateEvent/${DATAS}`,
          payload
        );
        if (response.data?.status) {
          setModalState({
            open: true,
            type: "success",
            message: response.data?.message,
            redirectPath: "/user/calenderList",
          });
          setFormData({
            name: "",
            subject: "",
            content: "",
            upload_path: null,
          });

        } else {
          setModalState({
            open: true,
            type: "error",
            message: response.data?.message,
            redirectPath: "",
          });
          throw new Error(response.data?.message || "Event created failed");
        }
      } else {
        const payload = {
          client_id: client_id,
          event_category: formData.category.value,
          start_date: formData.fromDate?.format("YYYY-MM-DD"),
          end_date: formData.toDate?.format("YYYY-MM-DD"),
          start_time: formatTime(formData.fromTime),
          end_time: formatTime(formData.toTime),
          event_subject: formData.subject,
          event_venue: formData.venue,
          event_description: formData.description,
          is_visible_to_all_school: 1,
          my_schools: school_id,
          created_by: userId
        };
        const response = await AxiosInstance.post(
          `/school/createEvent`,
          payload
        );
        if (response.data?.status) {


          setModalState({
            open: true,
            type: "success",
            message: response.data?.message,
            redirectPath: "/user/calenderList",
          });
    
          setFormData({
            name: "",
            subject: "",
            content: "",
            upload_path: null,
          });
        } else {

          setModalState({
            open: true,
            type: "error",
            message: response.data?.message,
            redirectPath: "",
          });
          throw new Error(response.data?.message || "Event created failed");
        }
      }


    }
  };
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await AxiosInstance.get("/school/events-categories");

        if (response.data.status) {
          setCategoryList(response.data.data);
        } else {
          throw new Error(response.data.message);
        }
      } catch (err) {
        console.log(err);

      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await AxiosInstance.get(`school/viewEvent/${DATAS}`);

        if (response.data.status) {
          const eventData = response.data.data?.[0];
          if (!eventData) return;

          setFormData((prev) => ({
            ...prev,

            category:
              categoryOptions.find(
                (opt) => opt.value === eventData.event_category
              ) || "",

            school: clientData.school_name,

            fromDate: eventData.start_date
              ? dayjs(eventData.start_date)
              : null,

            toDate: eventData.end_date
              ? dayjs(eventData.end_date)
              : null,

            fromTime: eventData.start_time
              ? dayjs(eventData.start_time, "HH:mm:ss")
              : null,

            toTime: eventData.end_time
              ? dayjs(eventData.end_time, "HH:mm:ss")
              : null,

            subject: eventData.event_subject || "",
            venue: eventData.event_venue || "",
            description: eventData.event_description || "",
          }));
        } else {
          throw new Error(response.data.message);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (DATAS) {
      fetchData();
    }
  }, [DATAS]);

  const { translations } = useSelector((state) => state.language);
  const today = dayjs().startOf("day");
  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;

    setModalState((prev) => ({
      ...prev,
      open: false,
    }));

    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };
  return (

    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />
      <form onSubmit={handleSubmit} className="row g-4">
        {/* Page Heading */}
        <div className={styles.pageHeader}>
          <div className={styles.pageTitle}>
            <span className={styles.titleIcon}>🏢</span>
            <h2>Event Setup</h2>
          </div>
          <div className={styles.divider} />
        </div>

        {/* Category */}
        <div className="col-md-6 px-2">
          <CustomDropdown
            label={translations.labels.category}
            name="category"
            value={formData.category}
            onChange={(option) => handleDropdownChange("category", option)}
            options={categoryOptions}
            placeholder={translations.labels.category}
            required
            error={submitted && errors.category}
          />
        </div>

        {/* Empty column (for layout like screenshot) */}
        <div className="col-md-6 px-2">
          <CustomTextInput
            label={translations.labels.school}
            name="School"
            value={formData.school}
            // onChange={handleInputChange}
            placeholder={translations.labels.schoolPlaceholder}
          // required
          // error={submitted && errors.description}
          />
        </div>

        {/* From Date */}
        <div className="col-md-6 px-2">
          <CustomDatePicker
            label={translations.labels.fromDate}
            name="fromDate"
            value={formData.fromDate}
            minDate={today}
            onChange={(value) => handleDateChange("fromDate", value)}
            placeholder="Ex: 30/07/2016"
            required
            error={submitted && errors.fromDate}
          />
        </div>

        {/* To Date */}
        <div className="col-md-6 px-2">
          <CustomDatePicker
            label={translations.labels.toDate}
            name="toDate"
            value={formData.toDate}
            onChange={(value) => handleDateChange("toDate", value)}
            placeholder="Ex: 30/07/2016"
            required
            error={submitted && errors.toDate}
            minDate={formData.fromDate}
          />
        </div>

        {/* From Time */}
        <div className="col-md-6 px-2">
          <CustomTimePicker
            label={translations.labels.fromTime}
            name="fromTime"
            value={formData.fromTime}

            onChange={(value) => handleTimeChange("fromTime", value)}
            placeholder="Ex: 09:30"
            required
            error={submitted && errors.fromTime}
          />
        </div>

        {/* To Time */}
        <div className="col-md-6 px-2">
          <CustomTimePicker
            label={translations.labels.toTime}
            name="toTime"
            value={formData.toTime}
            onChange={(value) => handleTimeChange("toTime", value)}
            placeholder="Ex: 12:00"
            required
            error={submitted && errors.toTime}
          />
        </div>

        {/* Subject */}
        <div className="col-md-6 px-2">
          <CustomTextInput
            label={translations.labels.subject}
            name="subject"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder={translations.labels.subjectPlaceholder}
            required
            error={submitted && errors.subject}
          />
        </div>

        {/* Venue */}
        <div className="col-md-6 px-2">
          <CustomTextInput
            label={translations.labels.venue}
            name="venue"
            value={formData.venue}
            onChange={handleInputChange}
            placeholder={translations.labels.venuePlaceholder}
            required
            error={submitted && errors.venue}
          />
        </div>

        {/* Description */}
        <div className="col-md-6 px-2">
          <CustomTextInput
            label={translations.labels.description}
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder={translations.labels.descriptionPlaceholder}
            required
            error={submitted && errors.description}
          />
        </div>

        {/* Action Buttons */}
        <div className={styles.actionButtons}>
          <CustomButton
            variant="contained"
            onClick={handleSubmit} // 🔁 changed from handleSave
            className={styles.saveButton}
            fullWidth={false}
            loading={loading}
            loadingText="Saving..."
          >
            {translations.labels.save}
          </CustomButton>

          <CustomButton
            variant="contained"
            onClick={handleCancel}
            className={styles.cancelButton}
            fullWidth={false}
            disabled={loading}
          >
            {translations.labels.cancel}

          </CustomButton>
        </div>
      </form>
    </>

  );
};

export default CalendarInfoCreate;
